import type { CartAddressData } from 'services/types';
import type { BillingAddressFields } from './types';

/** Merges normalized billing fields into the existing address without mutating it. */
export function updateBillingAddress(
  billingAddress: CartAddressData | undefined,
  billingFields: BillingAddressFields
): CartAddressData {
  return { ...billingAddress, ...billingFields };
}
